module.exports = __webpack_public_path__ + "static/Blue_header-c238d31c85aa8960cb1f5a650eb6fb5a.png";